import styled from 'styled-components'
export default styled.main`

	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;

	.spinner {
		min-height: 100vh;
		width: 100%;
	}

	.section-container > .ant-row > .ant-col {
		display: flex;
		justify-content: center;
		align-items: start;
		min-height: 100vh;
	}

	.login-form-container {
		max-width: 400px;
		width: 100%;
		height: 100%;
		border-radius: 8px;
		padding: 16px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		min-height: 400px;
		.login__logo-container {
			width: 100%;
		}
		.login__logo {
			width: 200px;
		}
		form {
			width: 100%;
		}
		.button-container {
			margin-top: 32px;
		}
		.handler-button {
			max-width: 100%;
			width: 100%;
		}
	}
	
`